import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=d2107826&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=d2107826&prod&lang=scss"
import style1 from "./Faq.vue?vue&type=style&index=1&id=d2107826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2107826",
  null
  
)

export default component.exports